export class RaffleTermsAndConditions{
    title: string;
    body: string;
    
    
    
}